import { users } from './users';

export const amo_widget = {
  namespaced: true,
  modules: {
    'users': users
  }
};
